export var ConversationChannelTypeExtended;
(function (ConversationChannelTypeExtended) {
    ConversationChannelTypeExtended["Chat"] = "chat";
    ConversationChannelTypeExtended["Email"] = "email";
    ConversationChannelTypeExtended["Phone"] = "phone";
    ConversationChannelTypeExtended["InternalNote"] = "internal_note";
})(ConversationChannelTypeExtended || (ConversationChannelTypeExtended = {}));
export var ConversationMessageType;
(function (ConversationMessageType) {
    ConversationMessageType["Private"] = "private";
    ConversationMessageType["Assist"] = "assist";
    ConversationMessageType["Engage"] = "engage";
})(ConversationMessageType || (ConversationMessageType = {}));
